import { createSlice } from '@reduxjs/toolkit';
import { DataListType } from 'src/app/interface/requestList';

type RequestCommandState = {
  loading: boolean;
  data: IData;
};
type IData = {
  total: number;
  list: DataListType[];
};

const initialState: RequestCommandState = {
  loading: false,
  data: {
    total: 0,
    list: [],
  },
};

export const appealsListSlice = createSlice({
  name: 'appealsList',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setData: (state, action) => {
      // @ts-ignore
      state.data = action.payload;
    },
  },
});

export default appealsListSlice.reducer;
